import { useTranslation } from 'react-i18next'

import type { FulfillmentOrderDisplayStatusRoot } from '@repo/sdk'

import type { StatusConfig } from '../../components/StatusBadge'

export type FoStatusConfig = Record<FulfillmentOrderDisplayStatusRoot, StatusConfig>

export function useFoDisplayStatusConfig(): FoStatusConfig {
  const { t } = useTranslation()

  return {
    PAYMENT_PENDING: { color: 'orange', label: t('common.status.paymentPending') },
    AWAITING_REPAYMENT: { color: 'yellow', label: t('common.status.awaitingRepayment') },
    PAID: { color: 'blue', label: t('common.status.paid') },
    SHIPPED: { color: 'purple', label: t('common.status.shipped') },
    DELIVERED: { color: 'cyan', label: t('common.status.delivered') },
    CONFIRMED: { color: 'green', label: t('common.status.confirmed') },
    ALL_CANCELLED: { color: 'red', label: t('common.status.cancelledReturned') },
    ALL_RETURNED: { color: 'red', label: t('common.status.allReturned') },
  }
}
